import { autoGeneratedReducer } from '@hh.ru/redux-create-reducer';
import { SalaryRange } from '@hh.ru/types-hh-microcore';

import { VacancyCompensation } from 'src/types/compensation';
import MarketRange from 'src/types/marketRange';
import { VacancyAdvice } from 'src/types/vacancyAdvices';

interface SalaryMarketRangeData {
    advices: VacancyAdvice[];
    compensation: VacancyCompensation;
    marketRange: MarketRange;
    salaryRange: SalaryRange;
    vacancyId: number;
}

const INITIAL_STATE: SalaryMarketRangeData = {
    advices: [] as VacancyAdvice[],
    compensation: {} as VacancyCompensation,
    marketRange: {} as MarketRange,
    salaryRange: SalaryRange.NotSpecified,
    vacancyId: 0,
};

export default autoGeneratedReducer<SalaryMarketRangeData>(INITIAL_STATE);
